import {Component, Input, OnInit} from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @Input()
  progressValue: number;
  constructor() { }

  ngOnInit(): void {
  }

}
